import { sendGlobalTrackingThunk } from '../../../redux/core/thunks.js';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.js';
import { trackFormFieldError } from '../buildPayloadsTyped/trackFormFieldError.js';
import { trackButtonClick } from '../buildPayloadsTyped/trackButtonClick.js';
import { usePasswordlessComponentStateBuilder } from '../../featureSpecific/passwordless/usePasswordlessComponentStateBuilder.js';
import { trackModalView } from '../buildPayloadsTyped/trackModalView.js';
import { useLinkedinComponentStateBuilder } from '../../featureSpecific/linkedin/index.js';
import { trackFailedRequest } from '../buildPayloadsTyped/trackFailedRequest.js';
import { INITIAL_TRACKING_DELAY } from '../../constants.js';
import { twoStepTrackingComponentStateSelector } from '../../../redux/core/wrapperContext/wrapperContextSlice.js';
import { trackingResetPasswordStateSelector } from '../../../views/ResetPassword/resetPasswordSlice.js';
export const useTrack = (featureGroup) => {
    const dispatch = useAppDispatch();
    const componentState = {
        passwordLess: usePasswordlessComponentStateBuilder(),
        linkedin: useLinkedinComponentStateBuilder(),
        twoStep: useAppSelector(twoStepTrackingComponentStateSelector),
        resetPassword: useAppSelector(trackingResetPasswordStateSelector),
    };
    const trackModalComponentVisible = (shouldDelayTracking = true) => {
        const track = () => {
            dispatch(sendGlobalTrackingThunk(trackModalView, {
                ...(featureGroup !== 'standard' && {
                    componentState: componentState[featureGroup],
                }),
            }));
        };
        shouldDelayTracking ? setTimeout(track, INITIAL_TRACKING_DELAY) : track();
    };
    const trackFailedAttempt = ({ formFailedAttemptsErrors, componentTitle, }) => {
        dispatch(sendGlobalTrackingThunk(trackFailedRequest, {
            formFailedAttemptsErrors,
            componentState: componentState[featureGroup],
            componentTitle,
        }));
    };
    const trackFieldError = ({ formFieldErrors, genericComponentState, }) => {
        dispatch(sendGlobalTrackingThunk(trackFormFieldError, {
            formFieldErrors,
            componentState: featureGroup === 'generic'
                ? genericComponentState
                : componentState[featureGroup],
        }));
    };
    const trackBtnClick = ({ uniqueName, genericComponentState, }) => {
        dispatch(sendGlobalTrackingThunk(trackButtonClick, {
            ...(featureGroup === 'standard' ||
                (featureGroup === 'generic' && !genericComponentState)
                ? {}
                : {
                    componentState: featureGroup !== 'generic'
                        ? componentState[featureGroup]
                        : genericComponentState,
                }),
            uniqueName,
        }));
    };
    return {
        trackFailedAttempt,
        trackFieldError,
        trackModalComponentVisible,
        trackBtnClick,
    };
};
//# sourceMappingURL=useTrack.js.map